<template>
  <v-autocomplete
    v-model="companyValue"
    @input="handleInput"
    :clearable="clearable"
    :dense="dense"
    :disabled="disabled"
    :items="companies"
    :item-value="itemValue"
    :loading="isLoading"
    :multiple="multiple"
    :outlined="outlined"
    :return-object="returnObject"
    :rules="rules"
    :search-input="search"
    item-text="name"
    :label="$t('categories.company.name')"
  ></v-autocomplete>
</template>

<script>
import CompanyService from "@/services/CompanyService"
export default {
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: true
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      search: "",
      isLoading: false,
      companyValue: null,
      companies: []
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue) this.companyValue = newValue
      }
    }
  },
  methods: {
    fetchData() {
      this.isLoading = true
      this.getData()
        .then(results => {
          this.companies = results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getData() {
      return CompanyService.getAll()
    },
    handleInput(newValue) {
      this.$emit("input", newValue)
    }
  }
}
</script>
